module.exports = __webpack_public_path__ + "img/Sicherheitstor.dde26219.jpg";